/* eslint-disable @stylistic/ts/indent */
import { PortfolioUpdateEnum } from '@/assets/global/enums/endpoints/PortfolioUpdateEnum'
import { CommitteeEnum } from '@/assets/global/enums/endpoints/CommitteeEnum'
import { getDepartmentDescriptionById } from '@/utils/constants/department.model.constants'
import { useUserStore } from '@/stores/userStore'

interface Ids {
  updates?: string
  version?: string
  committee?: string
  course?: string
  step?: string
}

export const RoutesRegionalUpdatesObject = [
  {
    regex: /^\/regional\/updates\/?$/,
    title: () => {
      const desc = getDepartmentDescriptionById(useUserStore().getRegional())
      return desc ? `Atualização de Portfólio - ${desc}` : 'Atualização de Portfólio'
    },
    breadcrumbTitle: 'Atualização de Portfólio',
    children: [
      {
        regex: /^\/[\d+]+\/?$/,
        title: async (ids: Ids) => {
          const areaId = Number(ids.updates)
          const versionId = ids.version

          const { data: areaData } =
            areaId > 0
              ? ((await useApiModified([
                  createUrl(
                    PortfolioUpdateEnum.AREA_ID.replace(
                      '{regionalAreaId}',
                      String(areaId),
                    ),
                    {
                      query: { versionId },
                    },
                  ),
                ])) as { data: any; response: any })
              : { data: undefined }

          return areaData?.value?.data?.regionalArea?.area?.name ?? ''
        },
        breadcrumb: true,
      },
      {
        regex: /^\/committee\/[\d+]+\/?$/,
        title: async (ids: Ids) => {
          const committeeId = Number(ids.committee)

          const { data: committeeData } =
            committeeId > 0
              ? ((await useApiModified([
                  createUrl(
                    CommitteeEnum.COMMITTEE_ID.replace(
                      '{id}',
                      String(committeeId),
                    ),
                  ),
                ])) as { data: any; response: any })
              : { data: undefined }

          const segment = committeeData?.value?.data?.segment
          return segment ? `Comitê - ${segment}` : 'Comitê'
        },
        breadcrumb: true,
        children: [
          {
            regex: /^\/course\/\d+(?:\?.*)?$/,
            title: async (ids: Ids) => {
              const courseVersionId = Number(ids.course)

              const { data: courseData } =
                courseVersionId > 0
                  ? ((await useApiModified([
                      createUrl(
                        CommitteeEnum.COURSE_VERSION.COURSE_NAME.replace(
                          '{courseVersionId}',
                          String(courseVersionId),
                        ),
                      ),
                    ])) as { data: any; response: any })
                  : { data: undefined }

              const courseName = courseData?.value?.data?.courseName ?? ''
              const step = ids.step === '9'
                ? ' | Plano de Curso'
                : ids.step
                  ? ` | Etapa ${ids.step}`
                  : ''

              return `${courseName}${step}`
            },
            breadcrumb: true,
          },
        ],
      },
    ],
  },
]

export const RoutesRegionalUpdatesComponents = [
  {
    path: '/regional/updates/committee/:committeeId/course/:courseVersionId',
    name: 'regional-committee-course',
    component: () => import('@/pages/regional/updates/committee/course.vue'),
    meta: {
      navActiveLink: 'regional-updates',
    },
  },
]
